
import { Component, OnInit, Inject } from '@angular/core';
//import { BidderOnlineProfileEModel, BaseEModel } from '../../models/admin-view-models';
import { AlertMessage, AlertMessages } from '../../_helpers/helperClasses';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IModalDialogData } from '../../_helpers/helperInterfaces';
import { AppLoggerService } from '../../_services/logger/app-logger.service';
import { tap, finalize } from 'rxjs/operators';
import { AuthenticationService } from '../../_services/security/authentication.service';



@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  formModalTitle: string = "Change Profile Account Password";
  formModalDisplayText: string = "";
  formRecord = {
    Email:'',
    Id: 0,
    OldPassword:'',
    NewPassword:'',
    ConfirmedPassword: ''
  };


  // ----------------------------------------
  // Flag to indicated that saving is currently happening
  // ----------------------------------------
  isLoadingResults = true;
  recordModified = false;
  saveRecordFlag = false;
  savingRecord = function () { return this.saveRecordFlag; };
  savingRecordStarted = function () { this.saveRecordFlag = true; };
  savingRecordCompleted = function () { this.saveRecordFlag = false; };
  // ----------------------------------------

  // Form
  typeBidderOnlineProfileForm: FormGroup;

  // Form Alerts
  modalFormAlerts: AlertMessages = new AlertMessages();

  // convenience getter for easy access to form fields
  get f() { return this.typeBidderOnlineProfileForm.controls; }

  // get Error Message
  getErrorMessage(ctrl: FormControl) {

    if (ctrl.hasError('required'))
      return "You must enter a value";
    if (ctrl.hasError('maxlength')) {
      var errMaxLth = ctrl.getError('maxlength');
      return "Max Length is (" + errMaxLth.requiredLength + ")";
    }

    if (ctrl.hasError('min')) {
      var errMin = ctrl.getError('min');
      return "Min required value is (" + errMin.min + ")";
    }

    if (ctrl.hasError('max')) {
      var errMax = ctrl.getError('max');
      return "Max required value is (" + errMax.max + ")";
    }

    if (ctrl.hasError('ngbDate')) {
      var errDt = ctrl.getError('ngbDate');
      return "Invalid Date :(" + errDt.invalid + ") expected: yyyy-mm-dd";
    }


    return "Unknown Error(s)";
  }

  // all errors
  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray)
        ? this.getAllErrors(control)
        : control.errors;
      if (errors) {
        acc[key] = errors;
        let errAlert = new AlertMessage();
        errAlert.Message = key;
        errAlert.AlertType = 'Error';

        this.modalFormAlerts.addMessage(errAlert);
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }

  // show all form errors
  showErrors(): void { this.getAllErrors(this.typeBidderOnlineProfileForm); }

  // Constructor
  constructor(
    public dialogRef: MatDialogRef<any>
    , @Inject(MAT_DIALOG_DATA) public formData: IModalDialogData
    , private formBuilder: FormBuilder
    , private _logger: AppLoggerService
    , private avdSrv: AuthenticationService
  ) {
    
    this.formRecord.Email = avdSrv.currentAppUserValue.username;
    this.formRecord.Id = avdSrv.currentAppUserValue.id;


  }


  ngOnInit() {
    // Build Form
    this.typeBidderOnlineProfileForm = this.formBuilder.group({

      NewPassword: ['', [Validators.required, Validators.maxLength(40)]]
      , OldPassword: ['', [Validators.required, Validators.maxLength(40)]]
      , ConfirmedPassword: ['', [Validators.required, Validators.maxLength(40)]]

    });


    // Reload Parent DDLs


  }




  ok(): void {
    if (this.typeBidderOnlineProfileForm.valid) {

      //this.avdSrv.UpdateBidderOnlineProfile(this.typeBidderOnlineProfileForm.value, this.formRecord.UniqueId, this.formRecord.ModifiedOn).pipe(
      //  tap(() => this.savingRecordStarted()),
      //  finalize(() => this.savingRecordCompleted()))
      //  .subscribe(data => {
      //    if (data.status == "OK") {
            this._logger.logSuccess('Password changed successfully.');
            this.dialogRef.close();
      //    }
      //    else {
      //      this._logger.logError('Error Creating New Bidder Online Profile Record');
      //      this.modalFormAlerts.setAlerts(data.alerts);

      //    }
      //  });

    }
  }

  // close Form
  onCancel = function () { this.dialogRef.close(); }

}
